import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../../services/apiClient';
import { GetServiceTypes } from "../../config/config";
export const fetchAllServiceType = createAsyncThunk(
  'serviceType/fetchAllServiceType',
  async (_arg: any, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(GetServiceTypes, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'mode': 'outlook'
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const serviceTypeSlice = createSlice({
  name: 'serviceType',
  initialState: {
    serviceType: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllServiceType.pending, (state) => {
        state.loading = true;
       // state.error = null;
      })
      .addCase(fetchAllServiceType.fulfilled, (state, action) => {
    
        state.loading = false;
        state.error = "200";
        state.serviceType = action.payload;
      })
      .addCase(fetchAllServiceType.rejected, (state, action) => {
     
        state.loading = false;
        state.error ="401";
      });
  },
});

export default serviceTypeSlice.reducer;
